import $ from "jquery";
import compile from "@bd-utils/handlerbars-helper";
import BD_Component from "@bd-core/bd-component";
import fb from "@bd-core/firebase";
import bdjs from "@bd-core/bdjs";
import CONFIG from "@bd-core/config";
import { getRoomAnswerById } from "@bd-stores/game-data";
import { getCurrentPageId } from "@bd-stores/user-progress";
import {
    getPlayers,
    getRoomStatus,
    getFinalTeamAnswers,
    getHintUsed,
} from "@bd-stores/game-progress";
import {
    maybeUpdateRoomStatus,
    updateRoomAnswer,
    saveFinalRoomAnswers,
} from "@bd-core/firebase-actions";
import gsap from "gsap";
import Draggable from "gsap/Draggable";
import IntroVideo from "@bd-utils/intro-video-room";
import OutroVideo from "@bd-utils/outro-video-room";
import Hints from "@bd-utils/hints";
import CompletionPopup from "@bd-utils/completion-popup";

export class RoomRevealSolve extends BD_Component {
    constructor() {
        super();

        this.id = "reveal_solve";
        this.templateID = "reveal_solve-template";

        this.elms = {
            puzzleContent: "#switchPuzzle",
            puzzleOverlay: ".js-puzzle-popup",
            openPuzzle: ".js-switchPuzzle-open",
            closePuzzle: ".js-switchPuzzle-close",
            puzzleItem: ".js-puzzle-item",
            panelItem: ".js-panel-item",
            actions: ".js-actions",
            submitBtn: ".js-submit-answer.answer",
            closeNotMatch: ".js-mismatch-close",
            answerMismatch: ".js-answer-mismatch",
            answerWaiting: ".js-answer-waiting",
            answerWrong: ".js-answer-wrong",
            background: ".js-screen-img",
            backgroundImage: ".screen__navigate",
            lightAnswer: ".js-sync-answer",
            resultFeedback: ".js-feedback",
            audioChallenge: ".js-audio-challenge",
            answerInput: ".js-answer-input",
            magnifier: ".magnifier",
            visibleImage: ".visibleImage",
            hiddenImage: ".hiddenImage",
            container: ".revealSolve__item",
            page: ".revealSolve",
            magnifierImg: ".revealSolve__magnifier",
            closeFeedback: ".js-close-feedback",
            answerBox: ".answerBox",
            navButton: ".navigation__button",
            useScanner: ".js-use-scanner",
            hint: ".hint",
        };

        this._events = this.getEvents();

        this.fbEvents = [];

        this.startX = 0;
        this.startY = 0;
        this.zoom = 100;
        this.hotspotSize = 21.5;
        this.isDown = false;
        this.cursorMoveEnabled = false;

        this.hints = new Hints();
        this.popupHint = [];
        this.completionPopup = new CompletionPopup();
    }

    /**
     * @returns {Array<BD_ComponentEvent>}
     */
    getEvents() {
        const elms = this.elms;
        return [
            {
                event: "click",
                selector: elms.puzzleItem,
                handler: this.chooseItem,
            },
            {
                event: "click",
                selector: elms.submitBtn,
                handler: this.onClickedSubmit,
            },
            {
                event: "click",
                selector: `${elms.openPuzzle}, ${elms.closePuzzle}`,
                handler: this.onTogglePuzzle,
            },
            {
                event: "click",
                selector: elms.closeNotMatch,
                handler: this.onTogglenotMatch,
            },
            {
                event: "wheel",
                selector: elms.background,
                handler: this.onBackgroundScroll,
            },
            {
                event: "keydown",
                selector: elms.answerInput,
                handler: this.onAnswerInput,
            },
            {
                event: "keyup",
                selector: elms.answerInput,
                handler: this.onAnswerInputKeyUp,
            },
            {
                event: "mousemove",
                selector: elms.container,
                handler: this.onMagnifierMove,
            },
            {
                event: "mousemove",
                selector: elms.page,
                handler: this.onCursorMove,
            },
            {
                event: "mousemove",
                selector: elms.answerBox,
                handler: this.onElementEnter,
            },
            {
                event: "mouseleave",
                selector: elms.answerBox,
                handler: this.onElementLeave,
            },
            {
                event: "mousemove",
                selector: elms.navButton,
                handler: this.onElementEnter,
            },
            {
                event: "mouseleave",
                selector: elms.navButton,
                handler: this.onElementLeave,
            },
            {
                event: "mouseleave",
                selector: elms.navButton,
                handler: this.onElementLeave,
            },
            {
                event: "mouseleave",
                selector: elms.container,
                handler: this.onMagnifierLeave,
            },
            {
                event: "click",
                selector: elms.closeFeedback,
                handler: this.onCloseFeedback,
            },
            {
                event: "click",
                selector: elms.useScanner,
                handler: this.onEnableCursorMove,
            },
        ];
    }

    onElementEnter() {
        const elms = this.elms;
        const $magnifier = $(elms.magnifierImg);

        $magnifier.addClass("hidden");
    }

    onElementLeave() {
        const elms = this.elms;
        const $magnifier = $(elms.magnifierImg);
        $magnifier.removeClass("hidden");
    }

    pickUpScanner(e) {
        const elms = this.elms;
        const $page = $(elms.page);
        const $pageWidth = $page.width();
        const $magnifier = $(elms.magnifierImg);
        const offset = $page.offset();
        const x = e.pageX - offset.left;
        const y = e.pageY - offset.top;

        $magnifier.css({
            left: x,
            top: y,
            width: $pageWidth * 0.05,
            display: "block",
        });
    }

    onCursorMove(e) {
        if (!this.cursorMoveEnabled) return;

        this.pickUpScanner(e);
    }

    onMagnifierMove(e) {
        if (!this.cursorMoveEnabled) return;

        const $item = $(e.currentTarget);
        const $magnifier = $item.find(".magnifier");
        const $hiddenImage = $item.find(".hiddenImage");
        const containerWidth = $item.width();
        const offset = $item.offset();
        const x = e.pageX - offset.left;
        const y = e.pageY - offset.top;
        const radius = containerWidth * 0.2;

        $magnifier.css({
            left: x - radius,
            top: y - radius,
            width: radius * 2,
            height: radius * 2,
            display: "flex",
        });

        $hiddenImage.css("clip-path", `circle(${radius}px at ${x}px ${y}px)`);
    }

    onMagnifierLeave() {
        const elms = this.elms;
        const $magnifier = $(elms.magnifier);
        const $hiddenImage = $(elms.hiddenImage);
        $magnifier.hide();
        $hiddenImage.css("clip-path", `circle(0px at 0 0)`);
    }

    onEnableCursorMove(e) {
        const elms = this.elms;
        const $page = $(elms.page);
        const $magnifier = $(elms.magnifierImg);

        if (this.cursorMoveEnabled) {
            this.cursorMoveEnabled = false;

            $magnifier.css("display", "none");
            $(elms.useScanner).removeClass("is-used");
            $($page).removeClass("scanner-enabled");
        } else {
            this.cursorMoveEnabled = true;
            $(elms.useScanner).addClass("is-used");
            $($page).addClass("scanner-enabled");

            this.pickUpScanner(e);
        }
    }

    beforeInit() {
        // Reset scanner state before initialization
        this.cursorMoveEnabled = false;
        const elms = this.elms;
        const $page = $(elms.page);
        const $magnifier = $(elms.magnifierImg);
        const $magnifierContainer = $(elms.magnifier);
        const $hiddenImage = $(elms.hiddenImage);

        // Ensure clean state
        $magnifier.css("display", "none");
        $magnifierContainer.hide();
        $hiddenImage.css("clip-path", `circle(0px at 0 0)`);
        $(elms.useScanner).removeClass("is-used");
        $($page).removeClass("scanner-enabled");

        this.render();
        this.setGameState();
        this.initIntroVideo();
        this.initOutroVideo();
        this.initHints();
        const roomStatus = getRoomStatus(this.roomId);
        if (roomStatus !== "is-status-completed") this.listenScannedUsers();
    }

    getModifiedData() {
        const modified = { ...this._data };
        const players = getPlayers();
        const onlinePlayers = players.filter((player) => player.isOnline);

        let _challenge = this._data.challenges;
        const defaultNormalImage = `${CONFIG.themeURL}/assets/images/filestack.png`;
        const defaultHoverImage = `${CONFIG.themeURL}/assets/images/filestack-hover.png`;
        const defaultImageBg = `${CONFIG.themeURL}/assets/images/bg-switch-puzzle-new.png`;

        const _image_bg = this._data.image_bg
            ? this._data.image_bg
            : defaultImageBg;

        _challenge = {
            normal_image: _challenge.normal_image
                ? _challenge.normal_image
                : defaultNormalImage,
            hover_image: _challenge.hover_image
                ? _challenge.hover_image
                : defaultHoverImage,
        };

        const hintHotspots = this._data.hotspots.filter(
            (h) => h["hotspot_type"] === "hint",
        );

        const hotspotCount = hintHotspots.length;
        const defaultValue = "50%";

        const newHints = this._data.hints.map((hint, i) => {
            this.popupHint.push({ ...hint });

            const font_fam = hint.hint_font_family.split("|");
            const font_name = font_fam[0];
            const font_category = font_fam[1];

            return {
                ...hint,
                font_family: `"${font_name}", ${font_category}`,
                has_image: hint.image,
                position_top:
                    hotspotCount > 0 && hintHotspots[i]
                        ? hintHotspots[i].position_top
                        : defaultValue,
                position_left:
                    hotspotCount > 0 && hintHotspots[i]
                        ? hintHotspots[i].position_left
                        : defaultValue,
            };
        });

        const _hotspots = this._data.hotspots
            .filter((h) => h["hotspot_type"] === "puzzle")
            .shift();

        const modifiedData = {
            ...modified,
            hints: newHints,
            hotspots: _hotspots,
            challenges: _challenge,
            image_bg: _image_bg,
            players: onlinePlayers,
        };

        return modifiedData;
    }

    render() {
        const modifiedData = this.getModifiedData();
        const isForcedOpenChallenge = modifiedData["force_open_challenge"];

        const htmlTemplate = $("#" + this.templateID).html();
        const html = compile(htmlTemplate, modifiedData);
        $(".app").html(html);

        if (isForcedOpenChallenge) {
            this.onForceOppenChallenge();
        }
    }

    onForceOppenChallenge() {
        const elms = this.elms;
        const $puzzleOverlay = $(elms.puzzleOverlay);
        const hasOpen = $puzzleOverlay.hasClass("is-open");
        const isOpened = !hasOpen;
        const blur = $(".app-blur");

        blur.toggleClass("is-blurred", isOpened);

        $puzzleOverlay.toggleClass("is-open", isOpened);
        this.toggleAudio();
    }

    setGameState() {
        const elms = this.elms;
        const roomID = this.roomId;
        const thisRoomStatus = getRoomStatus(roomID);
        const isHintUsed = getHintUsed(roomID);

        const possibleStatuses = [
            "is-status-open",
            "is-status-started",
            "is-status-completed",
        ];

        gsap.registerPlugin(Draggable);
        let companions;

        Draggable.create(".js-draggable", {
            bounds: $(".screen__container"),
            dragResistance: 0.5,
            edgeResistance: 1,
            type: "x,y",
            zIndexBoost: false,
            onPress: function () {
                const screens = document.querySelectorAll(".js-draggable");
                let i = screens.length;
                companions = [];
                RoomRevealSolve.prototype.startX = this.x;
                RoomRevealSolve.prototype.startY = this.y;
                while (--i > -1) {
                    if (companions[i] !== this.target) {
                        companions.push({
                            element: screens[i],
                            x: gsap.getProperty(screens[i], "x"),
                            y: gsap.getProperty(screens[i], "y"),
                        });
                    }
                }
                gsap.killTweensOf(".js-draggable");
            },
            onDrag: function () {
                let i = companions.length,
                    deltaX = this.x - RoomRevealSolve.prototype.startX,
                    deltaY = this.y - RoomRevealSolve.prototype.startY,
                    companion;
                while (--i > -1) {
                    companion = companions[i];
                    gsap.set(companion.element, {
                        x: companion.x + deltaX,
                        y: companion.y + deltaY,
                    });
                }
            },
        });

        if (thisRoomStatus) {
            const $status = $(".js-room-status");
            $status.removeClass(possibleStatuses);
            $status.addClass(thisRoomStatus);
        }

        if (thisRoomStatus == "is-status-completed") {
            const finalRoomAnswers = getFinalTeamAnswers(roomID);

            this.completionPopup.show(roomID, false, finalRoomAnswers);

            $(elms.answerInput)
                .addClass("is-locked")
                .prop("disabled", true)
                .html(`${finalRoomAnswers}`);
            $(elms.submitBtn).prop("disabled", true);

            $(".js-reuse-challenge").addClass("is-completed");
            $(".app__page").addClass("is-room-completed");
        }

        if (isHintUsed) {
            $(".hint").addClass("is-used");
        } else {
            $(".hint").removeClass("is-used");
        }
    }

    // ============================== CUSTOM FUNCTION
    onBackgroundScroll(e) {
        let delta = e.originalEvent.deltaY < 0 ? "up" : "down";
        if (delta === "up" && this.zoom < 120) {
            this.zoom += 2;
            this.hotspotSize += 0.6;
        } else if (delta === "down" && this.zoom > 100) {
            this.zoom -= 2;
            this.hotspotSize -= 0.6;
        }
        $(this.elms.background).css({
            width: `${this.zoom}%`,
            height: `${this.zoom}%`,
            transform: `translate(-50%, -50%)`,
        });
        $(".screen__navigate").css({
            width: `${this.zoom}%`,
            height: `${this.zoom}%`,
            transform: `translate(-50%, -50%)`,
        });
        $(".js-screen-hotspot").css({
            cssText: `width: calc(1rem + ${this.hotspotSize}vw)`,
        });
        this.startX = 0;
        this.startY = 0;
        gsap.set(".js-draggable", { clearProps: "transform" });
    }

    onTogglenotMatch() {
        const $answerMismatch = $(this.elms.answerMismatch);
        const hasOpen = $answerMismatch.hasClass("is-open");
        const isOpened = !hasOpen;

        $answerMismatch.toggleClass("is-open", isOpened);
    }

    onCloseFeedback() {
        const elms = this.elms;
        const $actions = $(elms.actions);
        const $feedback = $(elms.resultFeedback);
        $actions.removeClass("active");
        setTimeout(() => {
            $feedback.removeClass("is-correct");
            $feedback.removeClass("is-incorrect");
        }, 300);
    }

    chooseItem(e, el) {
        const $el = $(el);
        const elms = this.elms;
        const itemId = $el.data("id");

        $el.toggleClass("selected");
        $(elms.panelItem).removeClass("is-incorrect");
        $(elms.resultFeedback).removeClass("is-incorrect");
        $(elms.confirmation).prop("disabled", false);

        // Handle audio muting when item is deselected
        if (!$el.hasClass("selected")) {
            // Item was deselected, mute the corresponding audio
            const audioElement = document.getElementById(itemId);
            if (audioElement && audioElement.tagName === "AUDIO") {
                const audio = /** @type {HTMLAudioElement} */ (audioElement);
                audio.muted = true;
                audio.pause();
            }
        } else {
            // Item was selected, unmute the corresponding audio
            const audioElement = document.getElementById(itemId);
            if (audioElement && audioElement.tagName === "AUDIO") {
                const audio = /** @type {HTMLAudioElement} */ (audioElement);
                audio.muted = false;
            }
        }

        const selectedItems = $(elms.puzzleItem + ".selected").length;
        const hasSelectedItem = selectedItems > 0;

        $(elms.actions).toggleClass("active", hasSelectedItem);
    }

    onClickedSubmit() {
        const userAnswer = $(this.elms.answerInput).val().toString().trim();
        if (!userAnswer) return;

        const roomID = this.roomId;
        const currentPlayerId = CONFIG.user.id;
        let roomStatus = "is-status-started";

        let roomAnswer = getRoomAnswerById(roomID);
        const isCorrect = roomAnswer.includes(userAnswer);
        const state = isCorrect ? "is-correct" : "is-incorrect";
        $(this.elms.answerBox).addClass(state);

        if (isCorrect) {
            roomStatus = "is-status-completed";

            this.outroVideo.startVideo();

            updateRoomAnswer(roomID, {
                [currentPlayerId]: {
                    answers: userAnswer,
                    isCorrect: isCorrect,
                },
            });
            saveFinalRoomAnswers(roomID, userAnswer);
        }

        maybeUpdateRoomStatus(roomID, roomStatus);
    }

    getCorrectAnswer(answers) {
        const playersAnswers = bdjs.indexedObjectToArray(answers);
        const firstCorrectAnswer = playersAnswers.find(
            (answer) => answer.isCorrect,
        );

        return firstCorrectAnswer?.answers;
    }

    checkIsAllAnswered(answers) {
        const players = getPlayers();
        const totalOnlinePlayer = players.filter((p) => p.isOnline).length;

        if (answers == null) return false;

        const totalPlayerAnswer = Object.keys(answers).length;

        if (totalPlayerAnswer < totalOnlinePlayer) return false;

        return true;
    }

    checkIsAllAnswersCorrect(answers) {
        const playersAnswers = bdjs.indexedObjectToArray(answers);
        const isAllCorrect = playersAnswers.every((answer) => answer.isCorrect);

        return isAllCorrect;
    }

    setSyncAnswerUI(playerAnswers) {
        const elms = this.elms;

        Object.keys(playerAnswers).forEach(function (playerId) {
            const answer = playerAnswers[playerId];
            const answerState = answer.isCorrect
                ? "is-correct"
                : "is-incorrect";

            $(elms.lightAnswer + `[data-user-id="${playerId}"]`).addClass(
                answerState,
            );
        });
    }

    /**
     * If current user hasn't answered anything, don't do anything
     * If all user already submit the answer, room completed
     *
     * That is only applied for user that are currently online, offline user
     * would be ignored
     *
     * @param {*} snapshot
     */
    scanUsersListener(snapshot) {
        const playersAnswer = snapshot.val();
        const completed = "is-status-completed";
        const roomID = getCurrentPageId();
        const firstAnswer = this.getCorrectAnswer(playersAnswer);
        const hasAllPlayersAnswered = this.checkIsAllAnswered(playersAnswer);
        const isAllAnswerCorrect = this.checkIsAllAnswersCorrect(playersAnswer);
        const hasBeenCompleted = getRoomStatus(roomID) === completed;

        if (hasBeenCompleted) return;

        if (playersAnswer == null) return;

        this.setSyncAnswerUI(playersAnswer);

        if (!hasAllPlayersAnswered) return;

        if (!isAllAnswerCorrect) return;

        saveFinalRoomAnswers(roomID, firstAnswer);
        maybeUpdateRoomStatus(roomID, completed);
    }

    onTogglePuzzle() {
        const elms = this.elms;
        const $puzzleOverlay = $(elms.puzzleOverlay);
        const hasOpen = $puzzleOverlay.hasClass("is-open");
        const isOpened = !hasOpen;
        const blur = $(".app-blur");

        blur.toggleClass("is-blurred", isOpened);

        $puzzleOverlay.toggleClass("is-open", isOpened);
        this.toggleAudio();
    }

    toggleAudio() {
        const elms = this.elms;
        const audioElements = $(elms.audioChallenge).toArray();
        audioElements.forEach(function (audio) {
            const audioElement = /** @type {HTMLAudioElement} */ (audio);
            if (audioElement.paused) {
                audioElement.play();
            } else {
                audioElement.currentTime = 0;
                audioElement.pause();
            }
        });
    }

    onAnswerInput(e) {
        const elms = this.elms;
        const $answerInput = $(elms.answerInput);
        const answer = $answerInput.val();
        const isEnterKey = e.key === "Enter" || e.keyCode === 13;

        if (isEnterKey) {
            e.preventDefault();
            const hasValue = String(answer).length > 0;
            if (hasValue) {
                $(elms.submitBtn).trigger("click");
            }
        } else {
            $(this.elms.answerBox).removeClass("is-incorrect");
        }
    }

    onAnswerInputKeyUp() {
        const elms = this.elms;
        const $answerInput = $(elms.answerInput);
        const answer = $answerInput.val();
        const hasValue = String(answer).length > 0;
        $(elms.submitBtn).prop("disabled", !hasValue);
    }

    /**
     * Callback to check whether the room is ready to finish
     */
    maybeReadyToFinish() {
        if (this.isTheRoomFinish()) return;

        const roomID = this.roomId;
        fb.get(`${fb.roomsPath}/${roomID}/answers`).then(
            this.scanUsersListener.bind(this),
        );
    }

    /**
     * Listener
     * @param {boolean} off turn on/off the event listener
     */
    listenScannedUsers(off = false) {
        const roomID = this.roomId;
        const path = `${fb.roomsPath}/${roomID}/answers`;
        const scanHandler = (data) => this.scanUsersListener(data);
        const finishHandler = () => this.maybeReadyToFinish();

        if (off) {
            this.fbEvents.forEach((fn) => fn.call());
            this.fbEvents = [];
        } else {
            const ansListener = fb.onValue(path, scanHandler);
            const plyListerner = fb.onValue(fb.playersPath, finishHandler);

            this.fbEvents.push(ansListener);
            this.fbEvents.push(plyListerner);
        }
    }

    isTheRoomFinish() {
        return getRoomStatus(this.roomId) == "is-status-completed";
    }

    beforeDestroy() {
        // if(this._data.must_in_room) this.cancel();
        this.listenScannedUsers(true);

        // Reset scanner state
        this.cursorMoveEnabled = false;
        const elms = this.elms;
        const $page = $(elms.page);
        const $magnifier = $(elms.magnifierImg);
        const $magnifierContainer = $(elms.magnifier);
        const $hiddenImage = $(elms.hiddenImage);

        // Hide magnifier and reset styles
        $magnifier.css("display", "none");
        $magnifierContainer.hide();
        $hiddenImage.css("clip-path", `circle(0px at 0 0)`);

        // Remove scanner classes
        $(elms.useScanner).removeClass("is-used");
        $($page).removeClass("scanner-enabled");

        if (this.introVideo) {
            this.introVideo.cleanup();
            this.introVideo = null;
        }

        if (this.outroVideo) {
            this.outroVideo.cleanup();
            this.outroVideo = null;
        }
    }

    initIntroVideo() {
        this.introVideo = new IntroVideo();
        this.introVideo.initForRoom("reveal-solve", "intro-video-reveal-solve");
    }

    initOutroVideo() {
        this.outroVideo = new OutroVideo();
        this.outroVideo.initForRoom("reveal-solve", "outro-video-reveal-solve");
    }

    initHints() {
        this.hints.init(this.roomId, this.popupHint);
    }
}
